export default "__VITE_ASSET__1C0tBDjQ__"